export default "__VITE_ASSET__7UZvSyHr__"